{
  "id": "campaign-132",
  "name": "Final Ground II",
  "seed": "campaign:132",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "~~~:........:...",
    ".~.:.....#..:#..",
    "...::::::::::...",
    "................",
    ".a.a..a..a..a.a.",
    "....~...........",
    "..a~~a....a..a..",
    "::::::::::::::::",
    "......,,.~~.....",
    ".a..a...#~~a..a.",
    ".........~~~....",
    "..........~....x",
    "...::::::::::...",
    "...:........:...",
    "...:........:...",
    "S.....QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 0,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 14,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "rare",
      "x": 11,
      "y": 11
    }
  ],
  "balls": {
    "first": 18,
    "every": 13
  },
  "generatorVersion": 3,
  "level": 132,
  "biome": "stadium",
  "par": {
    "reel": 8581,
    "push": 7580,
    "selfPropelled": 7092,
    "tractor": 5840,
    "zeroTurn": 4970,
    "fairway": 2943
  },
  "goldTime": {
    "reel": 8536,
    "push": 7502,
    "selfPropelled": 6996,
    "tractor": 5700,
    "zeroTurn": 4951,
    "fairway": 2910
  },
  "routeTries": {
    "par": {
      "reel": 4,
      "push": 0,
      "selfPropelled": 21,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 24
    },
    "gold": {
      "reel": 38,
      "push": 30,
      "selfPropelled": 25,
      "tractor": 48,
      "zeroTurn": 32,
      "fairway": 48
    }
  }
}
